'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export default angular.module('services.windows', [])

  /**
   * Factory for main tabs
   * 
   * manage of tabs
   */
  .factory('WindowService', function() {
    'ngInject';

    // tabs list
    var windows = [];

    return {

      /**
       * Gets the items.
       *
       * @return     {Array}  The tabs.
       */
      getItems: () => {
        return windows;
      },

      delItem: (id) => {
        windows.forEach((w, i) => {
          if(w.id == id){
            windows.splice(i, 1);
            return false;
          }
        });
      },

      /**
       * Adds an item.
       *
       * @param      {Object}  item    The item 
       */
      addItem: (item) => {

        var opened = windows.filter((wnd) => {
          return wnd.id == item.id;
        });

        if(opened.length > 0){
          // @TODO: activate window
          return;
        }

        if( ! item.x){
          // move to center
          var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
          var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
          item.x = ((width / 2) - (item.width / 2)) + dualScreenLeft;
        }

        if( ! item.y){
          // move to center
          var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
          var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
          item.y = ((height / 2) - (item.height / 2)) + dualScreenTop;
        }

        item.onClose = () => {
          windows.forEach((w, i) => {
            if(w.id == item.id){
              windows.splice(i, 1);
              return false;
            }
          });
          return true;
        };

        // add new item
        windows.push(item);
      }
    };

  })
  .name;




// WEBPACK FOOTER //
// ./client/components/windows/windows.service.js